// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ToggleMaterialAndAnswerButton_wrapper__26CdM"};